import { AlertBox, Link } from '@vp/swan'
import { Trans } from 'react-i18next'
import { useAppData } from '@app/providers/app-data-context'

interface ChannelStatusAlertProps {
  alertKey: string
}

export const ChannelStatusAlert = ({ alertKey }: ChannelStatusAlertProps) => {
  const { helpCenterUrls } = useAppData()
  const helpCenterPath = helpCenterUrls?.path ?? '/customer-care/help-center'

  return (
    <AlertBox skin="info">
      <Trans i18nKey={alertKey} components={{ helpCenterLink: <Link to={helpCenterPath} /> }} />
    </AlertBox>
  )
}
